Ext.define('SA.view.GeneralSettings', {
    alias: 'widget.general-settings',
    extend: 'SA.view.SimpleContainer',

    cls: 'sa-general-settings',

    initComponent() {
        this.items = [
            {
                xtype: 'simple-container',
                cls: 'sa-general-settings-sections',

                items: [
                    {
                        xtype: 'enable-geographic-units',
                        project: this.project
                    }, {
                        xtype: 'enable-historical-views',
                        enabled: this.project.isHistoricalViewsCreationEnabled(),
                        exampleCensusReleaseYear: this.project.getCountry() === 'USA' ? 2000 : 2006
                    }
                ]
            }, {
                xtype: 'sa-button',
                cls: 'sa-general-settings-delete-button',
                icon: 'sa-icon-close',
                itemId: 'deleteProjectBtn',
                text: 'Delete Project'
            }
        ];

        this.callParent();
    },

    initEvents() {
        this.callParent();

        this.down('#deleteProjectBtn').on('click', this.onClickDeleteProject, this);
        this.down('enable-historical-views').on('toggle', this.onToggleHistoricalViews, this);
    },

    onClickDeleteProject() {
        this.fireEvent('click:deleteProject');
    },

    onToggleHistoricalViews(enabled) {
        this.fireEvent('toggle:historicalViews', enabled);
    }
});